import Mousetrap from 'mousetrap';
import '../css/tailwind.css'
import '../css/icons.css'
import UIManager from './modules/ui-manager.js'
import { initGrids } from './modules/grids.js';
import UIUtils from './modules/ui-utils.js';
import { ValidationService } from 'aspnet-client-validation';

import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

export class App {

    init() {
        Mousetrap.bind('ctrl+q', function () {
            window.location.href = '/logout';
        });

        Mousetrap.bind('alt+s', () => {
            this.openSearchModal();
        });
        Mousetrap.bind('alt+b', function () {
            window.location.href = `/lightbox`;
        });

        new UIManager().init();

        initGrids();

        this.registerProgressBar();
        this.initSearchBox();
    }

    registerProgressBar() {

        document.querySelectorAll('a').forEach(link => {
            link.addEventListener('click', () => {
                NProgress.start();
            });
        });

        window.addEventListener('load', () => {
            NProgress.done();
        });
    }

    async initPageModule(modulePath, itemId) {
        try {
            const module = await import(`./pages/${modulePath}.js`);
            if (module && module.default) {
                const pageModule = new module.default(itemId);
                pageModule.init();
            }
        } catch (error) {
            console.error(`Error loading module '${modulePath}':`, error);
        }
    }

    async loadPageSpecificModules() {

        const path = window.location.pathname;

        let match;
        switch (true) {
            case (match = path.match(/^\/calendar\/([a-zA-Z0-9-]+)$/)) !== null:
                await this.initPageModule('edit-content-calendar', match[1]);
                break;
            case (match = path.match(/^\/automations\/([a-zA-Z0-9-]+)$/)) !== null:
                await this.initPageModule('edit-content-automations', match[1]);
                break;
            case (match = path.match(/^\/pf\/([a-zA-Z0-9-]+)$/)) !== null:
                await this.initPageModule('edit-content-pf', match[1]);
                break;
            case (match = path.match(/^\/settings\/ai$/)) !== null:
                await this.initPageModule('settings-ai');
                break;
            case (match = path.match(/^\/settings\/api-mon$/)) !== null:
                await this.initPageModule('settings-api-mon');
                break;
            case (match = path.match(/^\/calendar$/)) !== null:
                await this.initPageModule('calendar');
                break;
            case (match = path.match(/^\/automations\/([a-zA-Z0-9-]+)\/llm\/([a-zA-Z0-9-]+)$/)) !== null:
                await this.initPageModule('llm-view', match[2]);
                break;
            case (match = path.match(/^\/automations\/([a-zA-Z0-9-]+)\/preview$/)) !== null:
                await this.initPageModule('preview-groups', match[1]);
                break;
            case (match = path.match(/^\/view\/groups\//)) !== null:
                await this.initPageModule('preview-groups', null);
                break;
            case (match = path.match(/^\/groups(\/[a-zA-Z0-9-]+)?$/)) !== null:
                await this.initPageModule('preview-groups', new URLSearchParams(window.location.search).get('id'));
                break;
            case (match = path.match(/^\/groups$/)) !== null:
                await this.initPageModule('preview-groups', null);
                break;
            case (match = path.match(/^\/search\/groups$/)) !== null:
                await this.initPageModule('preview-groups', null);
                break;
            case (match = path.match(/^\/settings\/content-filter$/)) !== null:
                await this.initPageModule('reject-filters');
                break;
            case (match = path.match(/^\/history$/)) !== null:
                await this.initPageModule('publish-history-index');
                break;
            case (match = path.match(/^\/history\/([a-zA-Z0-9]+)$/)) !== null:
                await this.initPageModule('publish-history', match[1]);
                break;
        }
    }

    openSearchModal() {

        const existingModal = document.querySelector('.tingle-modal.tingle-modal--visible');

        if (existingModal) {
            return; // Exit if a modal is already open
        }

        const modal = UIUtils.openModal('/modal/search', {}, () => {

            const cancelButton = modal.modal.querySelector('.cancel-btn');

            if (cancelButton) {
                cancelButton.addEventListener('click', () => modal.close());
            }

            const formElement = modal.modal.querySelector('#modalForm');
            const searchModeInput = modal.modal.querySelector('#SearchMode');
            const contentTags = modal.modal.querySelectorAll('.content-tag');
            const searchField = formElement.querySelector('input[name="Query"]'); // Get the search field

            if (formElement) {

                // Implement the switch functionality
                contentTags.forEach(tag => {

                    tag.addEventListener('click', () => {

                        // If the clicked tag doesn't have the "on" class, switch to it
                        if (!tag.classList.contains('on')) {
                            contentTags.forEach(t => t.classList.remove('on'));
                            tag.classList.add('on');
                            searchModeInput.value = tag.getAttribute('data-id');
                        }

                    });
                });

                if (searchField) {
                    setTimeout(() => {
                        searchField.focus();
                    }, 100);
                }

                // Handle form submission with validation
                formElement.addEventListener('submit', async (event) => {
                    event.preventDefault(); // Prevent the default form submission

                    // Initialize ValidationService and validate the form
                    const validationService = new ValidationService();
                    validationService.bootstrap({ root: formElement });

                    const isValid = await validationService.isValid(formElement, true);

                    if (!isValid) {
                        console.error('Validation failed');
                        return; // Stop if validation fails
                    }

                    // Proceed with redirection if validation succeeds
                    const query = formElement.querySelector('input[name="Query"]').value;
                    const searchMode = searchModeInput.value;

                    if (searchMode === 'pictures') {
                        window.location.href = `/search/pictures?q=${encodeURIComponent(query)}`;
                    } else {
                        window.location.href = `/search/groups?q=${encodeURIComponent(query)}`;
                    }
                });
            }
        },
            () => { },
            () => true);
    }

    initSearchBox() {
        const searchForm = document.querySelector('#searchForm');
        const searchModeInput = document.querySelector('#SearchMode');
        const contentTags = document.querySelectorAll('.content-tag');

        if (!searchForm) return;  // Exit if search form doesn't exist

        // Function to load saved search mode from localStorage
        const loadSearchMode = () => {
            const savedMode = localStorage.getItem('searchMode');
            if (savedMode) {
                searchModeInput.value = savedMode;

                // Update the UI (toggle button states)
                contentTags.forEach(tag => {
                    if (tag.getAttribute('data-id') === savedMode) {
                        tag.classList.add('on');
                    } else {
                        tag.classList.remove('on');
                    }
                });
            }
        };

        // Load the saved search mode when the page loads
        loadSearchMode();

        // Toggle functionality between groups and pictures
        contentTags.forEach(tag => {
            tag.addEventListener('click', () => {
                if (!tag.classList.contains('on')) {
                    contentTags.forEach(t => t.classList.remove('on'));
                    tag.classList.add('on');
                    searchModeInput.value = tag.getAttribute('data-id'); // Update search mode

                    // Save the selected mode in localStorage
                    localStorage.setItem('searchMode', tag.getAttribute('data-id'));
                }
            });
        });

        // Handle form submission
        searchForm.addEventListener('submit', function (event) {
            const query = searchForm.querySelector('input[type="search"]').value;
            const searchMode = searchModeInput.value;

            if (!query) {
                event.preventDefault(); // Prevent submission if search is empty
                return;
            }

            // Adjust the form action based on search mode
            if (searchMode === 'pictures') {
                searchForm.action = `/search/pictures`;
            } else {
                searchForm.action = `/search/groups`;
            }
        });
    }
}

document.addEventListener('DOMContentLoaded', async (e) => {
    const app = new App();
    app.init();
    await app.loadPageSpecificModules();
});